import { render, staticRenderFns } from "./LmProcessNewOrEdit.vue?vue&type=template&id=2b4874ea&scoped=true"
import script from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmProcessNewOrEdit.vue?vue&type=style&index=0&id=2b4874ea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4874ea",
  null
  
)

export default component.exports